var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-filtered-search',{attrs:{"placeholder":_vm.s__('Jobs|Search or filter jobs…'),"available-tokens":_vm.tokens,"value":_vm.filteredSearchValue,"search-text-option-label":_vm.__('Search for this text'),"terms-as-tokens":""},on:{"submit":_vm.onSubmit}})
}
var staticRenderFns = []

export { render, staticRenderFns }